import { h } from "preact";

import i18n from "../../i18n.js";
import { displayEuro } from "../../salaryHelper.js";
import { classNames, renderHtml } from "../../helpers.js";

export default function MonthlySalary({
  highlighted,
  inApp,
  result,
  type,
  ...props
}) {
  const monthlyGross = result.grossIncome / 12;
  const monthlyNet = result.netIncome / 12;

  return (
    <div class={props.class}>
      <p
        class={
          inApp ? "t-h6 color-brand-midnight" : "t-h5 color-brand-midnight"
        }
      >
        {i18n.t(`pages.${type}_calculator.result.monthly_salary.title`)}
      </p>

      <p
        class={classNames(
          "color-shades-charcoal mb-48",
          inApp ? "t-body3" : "t-body2"
        )}
      >
        {renderHtml(
          i18n.t(`pages.${type}_calculator.result.monthly_salary.description`, {
            salary: displayEuro(result.grossIncome),
            taxClass: result.taxClass,
            taxClassDesc: i18n.t(
              `pages.${type}_calculator.tax_class.${result.taxClass}`
            ),
          })
        )}
      </p>

      <p class="t-body3 color-brand-midnight flex-spaced pb-24 bordered--bottom">
        <span>
          {i18n.t(
            `pages.${type}_calculator.result.monthly_salary.monthly_gross`
          )}
        </span>
        <span class={highlighted && "page-title page-title--unpadded"}>
          {displayEuro(monthlyGross)}
        </span>
      </p>

      <div class="t-caption color-shades-charcoal mt-24">
        {i18n.t("pages.salary_calculator.result.taxes.label")}
      </div>
      <p class="t-body3 color-brand-midnight flex-spaced">
        <span>{i18n.t("pages.salary_calculator.result.taxes.income_tax")}</span>
        <span>{displayEuro(result.incomeTax / 12)}</span>
      </p>
      <p class="t-body3 color-brand-midnight flex-spaced">
        <span>
          {i18n.t("pages.salary_calculator.result.taxes.solidarity_surcharge")}
        </span>
        <span>{displayEuro(result.solidaritySurcharge / 12)}</span>
      </p>

      <div class="t-caption color-shades-charcoal mt-40">
        {i18n.t("pages.salary_calculator.result.social.label")}
      </div>
      <p class="t-body3 color-brand-midnight flex-spaced">
        <span>
          {i18n.t("pages.salary_calculator.result.social.pension_insurance")}
        </span>
        <span>
          {displayEuro(result.socialContributions.pensionInsurance / 12)}
        </span>
      </p>
      <p class="t-body3 color-brand-midnight flex-spaced">
        <span>
          {i18n.t(
            "pages.salary_calculator.result.social.unemployment_insurance"
          )}
        </span>
        <span>
          {displayEuro(result.socialContributions.unemploymentInsurance / 12)}
        </span>
      </p>
      <p class="t-body3 color-brand-midnight flex-spaced">
        <span>
          {i18n.t("pages.salary_calculator.result.social.health_insurance")}
        </span>
        <span>
          {displayEuro(result.socialContributions.healthInsurance / 12)}
        </span>
      </p>
      <p class="t-body3 color-brand-midnight flex-spaced pb-24 bordered--bottom">
        <span>
          {i18n.t(
            "pages.salary_calculator.result.social.long_term_care_insurance"
          )}
        </span>
        <span>
          {displayEuro(result.socialContributions.longTermCareInsurance / 12)}
        </span>
      </p>

      <p class="t-body3 color-brand-midnight flex-spaced mt-24">
        <span>
          {i18n.t(`pages.${type}_calculator.result.monthly_salary.monthly_net`)}
        </span>
        <span class={highlighted && "page-title page-title--unpadded"}>
          {displayEuro(monthlyNet)}
        </span>
      </p>
    </div>
  );
}
